import type { CreateClientFormData } from '@/types/clientsApiTypes';
import { sectionRegistry } from '../../utils/sectionRegistry';
import { EditSectionModal } from '../EditSectionModals/components/EditSectionModal';
import { ModalShell } from '../EditSectionModals/components/ModalShell';
import type { ModalKey } from '../EditSectionModals/types';

type ModalState =
  | { open: false }
  | { open: true; key: ModalKey; status: 'loading' }
  | { open: true; key: ModalKey; status: 'ready'; client: CreateClientFormData };

export function ModalHost(props: { state: ModalState; close: () => void }) {
  const { state, close } = props;
  if (!state.open) return null;

  const config = sectionRegistry[state.key];

  if (state.status === 'loading') {
    return <ModalShell isOpen title={config.title} subtitle={config.subtitle} onClose={close} isLoading />;
  }

  return <EditSectionModal isOpen={state.open} client={state.client} config={config} onClose={close} />;
}
